import React from "react";
import { Modal, PrimaryButton } from "../../components";

import { useHistory } from 'react-router-dom';

const UpgradeSubscriptionModal = ({
    isOpen,
    onClose,
    onManageDisableScrolling,
    planName,
    isPremium,
}) => {
    const history = useHistory();

    return (
        <Modal
            id="upgradeSubscriptionModal"
            isOpen={isOpen}
            onClose={onClose}
            onManageDisableScrolling={onManageDisableScrolling}
            usePortal
        >
            <div>
                <h3>Uppgradering krävs</h3>
                {isPremium ? <p>Du har nått det maximala antalet på 5 underanvändare som är tillåtet för Premium.</p>
                    : <p>
                        Din nuvarande plan inkluderar inte den här funktionen.
                    </p>}
                <p>
                    Uppgradera till <strong>{planName}</strong> för att låsa upp denna funktion.
                </p>

                <PrimaryButton
                    onClick={() => {
                        history.push("/subscriptions");
                        onClose();
                    }}
                >
                    Uppgradera plan
                </PrimaryButton>
            </div>
        </Modal>
    );
};

export default UpgradeSubscriptionModal;
